import {NgModule} from '@angular/core';
import {CountryListService} from './services/country/country-list.service';
import {PoiService} from './services/poi/poi.service';
import {PoiGroupService} from './services/poi-group/poi-group.service';
import {CookieService} from 'ngx-cookie-service';
import {SessionService} from './services/session/session.service';
import {UserService} from './services/user/user.service';
import {GroupService} from './services/group/group.service';

@NgModule({
  providers: [
    CookieService,
    CountryListService,
    GroupService,
    PoiGroupService,
    PoiService,
    SessionService,
    UserService
  ]
})
export class WebofficeCommonCoreModule {
}
